import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

// FormOfAddress Services
export function GetFormOfAddress(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/crm/formofaddress", headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetFormOfAddressWithId(formOfAddressId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/formofaddress/" +
        formOfAddressId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PostFormOfAddress(formOfAddressObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/crm/formofaddress",
      formOfAddressObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PutFormOfAddress(
  formOfAddressId,
  formOfAddressObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/formofaddress/" +
        formOfAddressId,
      formOfAddressObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function DeleteFormOfAddress(formOfAddressId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/formofaddress/" +
        formOfAddressId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

// Contacts Services

export function GetContacts(
  pageSize,
  pageNumber,
  searchValue,
  sortBy,
  sortOrder,
  activestate,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/contacts?SearchValue=" +
        searchValue +
        "&PageSize=" +
        pageSize +
        "&PageNumber=" +
        pageNumber +
        "&SortBy=" +
        sortBy +
        "&SortOrder=" +
        sortOrder + 
        "&ActiveState=" + 
        activestate,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetContactsWithId(contactId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/crm/contacts/contact/" + contactId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PostContacts(contractsObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/crm/contacts",
      contractsObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PutContacts(contactId, contractsObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + "/crm/contacts/" + contactId,
      contractsObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function DeleteContacts(contactId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + "/crm/contacts/" + contactId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

// Organisations Services

export function GetOragnisations(
  pageSize,
  pageNumber,
  searchValue,
  sortBy,
  sortOrder,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/organisations?SearchValue=" +
        searchValue +
        "&PageSize=" +
        pageSize +
        "&PageNumber=" +
        pageNumber +
        "&SortBy=" +
        sortBy +
        "&SortOrder=" +
        sortOrder,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PostOrganisation(organisationObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + "/crm/organisations",
      organisationObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetOrganisationWithId(organisationId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + "/crm/organisations/" + organisationId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function PutOrganisation(
  organisationId,
  organisationObject,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + "/crm/organisations/" + organisationId,
      organisationObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function DeleteOrganisation(organisationId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + "/crm/organisations/" + organisationId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetContactsByOrganisation(organisationId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/crm/contacts/organisation/" +
        organisationId,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetContractsAndResponsibilities(
  ContractNumberName,
  OnlyContractWithInactiveResponsible,
  RoleName,
  ResponsibleName,
  SortBy,
  SortOrder,
  PageNumber,
  PageSize,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        "/contractversionssearch/contractresponsibleroles?ContractNumberName=" +
        ContractNumberName +
        "&OnlyContractWithInactiveResponsible=" +
        OnlyContractWithInactiveResponsible +
        "&RoleName=" +
        RoleName +
        "&ResponsibleName=" +
        ResponsibleName +
        "&SortBy=" +
        SortBy +
        "&SortOrder=" +
        SortOrder +
        "&PageNumber=" +
        PageNumber +
        "&PageSize=" +
        PageSize,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

export function GetAdActiveStateEnum(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/enumlist/activestate", headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}